import React from 'react';

const PinterestIcon = (props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>>) => (
  <svg {...props} width="38" height="38" viewBox="0 0 38 38">
    <g id="Group_30471" data-name="Group 30471" transform="translate(-399 -8933)">
      <path
        id="pinterest-svgrepo-com"
        d="M71.317,2.476A9.264,9.264,0,0,0,64.838,0a10.186,10.186,0,0,0-7.512,2.9,8.559,8.559,0,0,0-2.533,5.932c0,2.689,1.125,4.753,3.008,5.521a1,1,0,0,0,.378.078A.842.842,0,0,0,59,13.751c.064-.239.211-.83.275-1.086a1.019,1.019,0,0,0-.273-1.1,3.511,3.511,0,0,1-.8-2.4,6.038,6.038,0,0,1,6.261-6.078c3.227,0,5.231,1.834,5.231,4.786a9.944,9.944,0,0,1-1.13,4.858A3.342,3.342,0,0,1,65.8,14.664,1.832,1.832,0,0,1,64.345,14a1.676,1.676,0,0,1-.294-1.456c.144-.609.34-1.244.53-1.858a11.5,11.5,0,0,0,.673-3.025,2.2,2.2,0,0,0-2.211-2.416c-1.68,0-3,1.707-3,3.886a5.777,5.777,0,0,0,.413,2.175c-.212.9-1.47,6.229-1.709,7.235-.138.587-.969,5.223.407,5.593,1.546.415,2.928-4.1,3.068-4.61.114-.415.513-1.984.757-2.949a4.674,4.674,0,0,0,3.117,1.2,6.952,6.952,0,0,0,5.582-2.793,11.211,11.211,0,0,0,2.1-6.855A7.905,7.905,0,0,0,71.317,2.476Z"
        transform="translate(354.684 8940.494)"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default PinterestIcon;
